import React from "react";
import { Typography, Space, Row, Col } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { AreaChart, Area } from "recharts";
import { PieChart, Pie, Cell } from "recharts";
import CustomCard from "../../blocks/Card/Card";

const { Text, Title } = Typography;

// Sample data for property index growth
const indexData = [
  { year: 1980, index: 1 },
  { year: 1990, index: 1.5 },
  { year: 2000, index: 2.2 },
  { year: 2010, index: 3.1 },
  { year: 2020, index: 4.5 },
  { year: 2024, index: 4.8 },
];

// Sample data for appreciation rate
const appreciationData = [
  { year: 2020, rate: 2.5 },
  { year: 2021, rate: 2.8 },
  { year: 2022, rate: 3.0 },
  { year: 2023, rate: 3.31 },
  { year: 2024, rate: 3.5 }, // Projected
];

const FSDData = [
  { name: "Confidence", value: 90 },
  { name: "Uncertainty", value: 10 },
];

const COLORS = ["#97c23c", "#FF8042"];

const MarketIndicatorsDashboard = () => {
  return (
    <CustomCard title={<Title level={4}>Market Indicators</Title>}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={16}>
            <Title level={4}>Property Index Growth (Since 1980)</Title>
            <ResponsiveContainer width="100%" height={200}>
              <LineChart data={indexData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="year" />
                <YAxis />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="index"
                  stroke="#8884d8"
                  activeDot={{ r: 8 }}
                />
              </LineChart>
            </ResponsiveContainer>
            <Text type="secondary">
              The property index shows steady growth since 1980, with some
              fluctuations over time.
            </Text>
          </Col>
          <Col xs={24} sm={24} md={8} style={{ marginTop: "20px" }}>
            <Title level={4}>Forecast Standard Deviation (FSD)</Title>
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie
                  data={FSDData}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={80}
                  fill="#8884d8"
                  paddingAngle={5}
                  dataKey="value"
                >
                  {FSDData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <Text strong>FSD: 0.1</Text>
            <Text type="secondary">
              The low FSD of 0.1 indicates high confidence in the valuation.
            </Text>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Title level={4}>Annual Appreciation Rate</Title>
            <ResponsiveContainer width="100%" height={200}>
              <AreaChart data={appreciationData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="year" />
                <YAxis />
                <Tooltip />
                <Area
                  type="monotone"
                  dataKey="rate"
                  stroke="#82ca9d"
                  fill="#82ca9d"
                />
              </AreaChart>
            </ResponsiveContainer>
            <Text type="secondary">
              The one-year change of 3.31% suggests moderate appreciation. The
              chart shows recent appreciation trends.
            </Text>
          </Col>
        </Row>
        <Text>
          These market indicators collectively suggest a stable and moderately
          growing real estate market in the area, with high confidence in the
          property's valuation.
        </Text>
      </Space>
    </CustomCard>
  );
};

export default MarketIndicatorsDashboard;
